import { type FC, type PropsWithChildren } from 'react';

import styles from './Footer.css';

export const Footer: FC<PropsWithChildren> = ({ children }) => {
  return <section className={styles['footer-section']}>{children}</section>;
};
